import {
  PostProcess,
  RenderTargetTexture,
  init_math_viewport,
  init_postProcess,
  init_renderTargetTexture
} from "./chunk-MN6RHL7T.mjs";
import {
  Texture,
  init_texture
} from "./chunk-OTLDKKRS.mjs";
import {
  init_math_path
} from "./chunk-I3LO7I7E.mjs";
import {
  init_math_size
} from "./chunk-2UWNS7HH.mjs";
import {
  init_math_frustum
} from "./chunk-KU6MOYBB.mjs";
import {
  SerializationHelper,
  init_decorators_serialization,
  init_math_plane
} from "./chunk-2WRXXKPX.mjs";
import {
  Color3,
  init_math_color
} from "./chunk-LWSYNDGD.mjs";
import {
  AbstractEngine,
  init_abstractEngine
} from "./chunk-YVKSXECI.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  TmpVectors,
  ToLinearSpace,
  Vector2,
  Vector3,
  init_math_constants,
  init_math_vector
} from "./chunk-KXFHISWH.mjs";
import {
  Clamp,
  init_math_scalar_functions
} from "./chunk-73HVJB5H.mjs";
import {
  RegisterClass,
  init_typeStore
} from "./chunk-PMCXIDBB.mjs";
import {
  __async,
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Maths/math.axis.js
var Space, Axis, Coordinate;
var init_math_axis = __esm({
  "node_modules/@babylonjs/core/Maths/math.axis.js"() {
    "use strict";
    init_math_vector();
    (function(Space2) {
      Space2[Space2["LOCAL"] = 0] = "LOCAL";
      Space2[Space2["WORLD"] = 1] = "WORLD";
      Space2[Space2["BONE"] = 2] = "BONE";
    })(Space || (Space = {}));
    Axis = class {
    };
    Axis.X = new Vector3(1, 0, 0);
    Axis.Y = new Vector3(0, 1, 0);
    Axis.Z = new Vector3(0, 0, 1);
    (function(Coordinate2) {
      Coordinate2[Coordinate2["X"] = 0] = "X";
      Coordinate2[Coordinate2["Y"] = 1] = "Y";
      Coordinate2[Coordinate2["Z"] = 2] = "Z";
    })(Coordinate || (Coordinate = {}));
  }
});

// node_modules/@babylonjs/core/Maths/math.vertexFormat.js
var PositionNormalVertex, PositionNormalTextureVertex;
var init_math_vertexFormat = __esm({
  "node_modules/@babylonjs/core/Maths/math.vertexFormat.js"() {
    "use strict";
    init_math_vector();
    PositionNormalVertex = class _PositionNormalVertex {
      /**
       * Creates a PositionNormalVertex
       * @param position the position of the vertex (defaut: 0,0,0)
       * @param normal the normal of the vertex (defaut: 0,1,0)
       */
      constructor(position = Vector3.Zero(), normal = Vector3.Up()) {
        this.position = position;
        this.normal = normal;
      }
      /**
       * Clones the PositionNormalVertex
       * @returns the cloned PositionNormalVertex
       */
      clone() {
        return new _PositionNormalVertex(this.position.clone(), this.normal.clone());
      }
    };
    PositionNormalTextureVertex = class _PositionNormalTextureVertex {
      /**
       * Creates a PositionNormalTextureVertex
       * @param position the position of the vertex (defaut: 0,0,0)
       * @param normal the normal of the vertex (defaut: 0,1,0)
       * @param uv the uv of the vertex (default: 0,0)
       */
      constructor(position = Vector3.Zero(), normal = Vector3.Up(), uv = Vector2.Zero()) {
        this.position = position;
        this.normal = normal;
        this.uv = uv;
      }
      /**
       * Clones the PositionNormalTextureVertex
       * @returns the cloned PositionNormalTextureVertex
       */
      clone() {
        return new _PositionNormalTextureVertex(this.position.clone(), this.normal.clone(), this.uv.clone());
      }
    };
  }
});

// node_modules/@babylonjs/core/Maths/math.js
var init_math = __esm({
  "node_modules/@babylonjs/core/Maths/math.js"() {
    "use strict";
    init_math_axis();
    init_math_color();
    init_math_constants();
    init_math_frustum();
    init_math_path();
    init_math_plane();
    init_math_size();
    init_math_vector();
    init_math_vertexFormat();
    init_math_viewport();
  }
});

// node_modules/@babylonjs/core/Maths/sphericalPolynomial.js
var SH3ylmBasisConstants, SH3ylmBasisTrigonometricTerms, applySH3, SHCosKernelConvolution, SphericalHarmonics, SphericalPolynomial;
var init_sphericalPolynomial = __esm({
  "node_modules/@babylonjs/core/Maths/sphericalPolynomial.js"() {
    "use strict";
    init_math_vector();
    init_math();
    SH3ylmBasisConstants = [
      Math.sqrt(1 / (4 * Math.PI)),
      -Math.sqrt(3 / (4 * Math.PI)),
      Math.sqrt(3 / (4 * Math.PI)),
      -Math.sqrt(3 / (4 * Math.PI)),
      Math.sqrt(15 / (4 * Math.PI)),
      -Math.sqrt(15 / (4 * Math.PI)),
      Math.sqrt(5 / (16 * Math.PI)),
      -Math.sqrt(15 / (4 * Math.PI)),
      Math.sqrt(15 / (16 * Math.PI))
      // l22
    ];
    SH3ylmBasisTrigonometricTerms = [
      () => 1,
      (direction) => direction.y,
      (direction) => direction.z,
      (direction) => direction.x,
      (direction) => direction.x * direction.y,
      (direction) => direction.y * direction.z,
      (direction) => 3 * direction.z * direction.z - 1,
      (direction) => direction.x * direction.z,
      (direction) => direction.x * direction.x - direction.y * direction.y
      // l22
    ];
    applySH3 = (lm, direction) => {
      return SH3ylmBasisConstants[lm] * SH3ylmBasisTrigonometricTerms[lm](direction);
    };
    SHCosKernelConvolution = [Math.PI, 2 * Math.PI / 3, 2 * Math.PI / 3, 2 * Math.PI / 3, Math.PI / 4, Math.PI / 4, Math.PI / 4, Math.PI / 4, Math.PI / 4];
    SphericalHarmonics = class _SphericalHarmonics {
      constructor() {
        this.preScaled = false;
        this.l00 = Vector3.Zero();
        this.l1_1 = Vector3.Zero();
        this.l10 = Vector3.Zero();
        this.l11 = Vector3.Zero();
        this.l2_2 = Vector3.Zero();
        this.l2_1 = Vector3.Zero();
        this.l20 = Vector3.Zero();
        this.l21 = Vector3.Zero();
        this.l22 = Vector3.Zero();
      }
      /**
       * Adds a light to the spherical harmonics
       * @param direction the direction of the light
       * @param color the color of the light
       * @param deltaSolidAngle the delta solid angle of the light
       */
      addLight(direction, color, deltaSolidAngle) {
        TmpVectors.Vector3[0].set(color.r, color.g, color.b);
        const colorVector = TmpVectors.Vector3[0];
        const c = TmpVectors.Vector3[1];
        colorVector.scaleToRef(deltaSolidAngle, c);
        c.scaleToRef(applySH3(0, direction), TmpVectors.Vector3[2]);
        this.l00.addInPlace(TmpVectors.Vector3[2]);
        c.scaleToRef(applySH3(1, direction), TmpVectors.Vector3[2]);
        this.l1_1.addInPlace(TmpVectors.Vector3[2]);
        c.scaleToRef(applySH3(2, direction), TmpVectors.Vector3[2]);
        this.l10.addInPlace(TmpVectors.Vector3[2]);
        c.scaleToRef(applySH3(3, direction), TmpVectors.Vector3[2]);
        this.l11.addInPlace(TmpVectors.Vector3[2]);
        c.scaleToRef(applySH3(4, direction), TmpVectors.Vector3[2]);
        this.l2_2.addInPlace(TmpVectors.Vector3[2]);
        c.scaleToRef(applySH3(5, direction), TmpVectors.Vector3[2]);
        this.l2_1.addInPlace(TmpVectors.Vector3[2]);
        c.scaleToRef(applySH3(6, direction), TmpVectors.Vector3[2]);
        this.l20.addInPlace(TmpVectors.Vector3[2]);
        c.scaleToRef(applySH3(7, direction), TmpVectors.Vector3[2]);
        this.l21.addInPlace(TmpVectors.Vector3[2]);
        c.scaleToRef(applySH3(8, direction), TmpVectors.Vector3[2]);
        this.l22.addInPlace(TmpVectors.Vector3[2]);
      }
      /**
       * Scales the spherical harmonics by the given amount
       * @param scale the amount to scale
       */
      scaleInPlace(scale) {
        this.l00.scaleInPlace(scale);
        this.l1_1.scaleInPlace(scale);
        this.l10.scaleInPlace(scale);
        this.l11.scaleInPlace(scale);
        this.l2_2.scaleInPlace(scale);
        this.l2_1.scaleInPlace(scale);
        this.l20.scaleInPlace(scale);
        this.l21.scaleInPlace(scale);
        this.l22.scaleInPlace(scale);
      }
      /**
       * Convert from incident radiance (Li) to irradiance (E) by applying convolution with the cosine-weighted hemisphere.
       *
       * ```
       * E_lm = A_l * L_lm
       * ```
       *
       * In spherical harmonics this convolution amounts to scaling factors for each frequency band.
       * This corresponds to equation 5 in "An Efficient Representation for Irradiance Environment Maps", where
       * the scaling factors are given in equation 9.
       */
      convertIncidentRadianceToIrradiance() {
        this.l00.scaleInPlace(SHCosKernelConvolution[0]);
        this.l1_1.scaleInPlace(SHCosKernelConvolution[1]);
        this.l10.scaleInPlace(SHCosKernelConvolution[2]);
        this.l11.scaleInPlace(SHCosKernelConvolution[3]);
        this.l2_2.scaleInPlace(SHCosKernelConvolution[4]);
        this.l2_1.scaleInPlace(SHCosKernelConvolution[5]);
        this.l20.scaleInPlace(SHCosKernelConvolution[6]);
        this.l21.scaleInPlace(SHCosKernelConvolution[7]);
        this.l22.scaleInPlace(SHCosKernelConvolution[8]);
      }
      /**
       * Convert from irradiance to outgoing radiance for Lambertian BDRF, suitable for efficient shader evaluation.
       *
       * ```
       * L = (1/pi) * E * rho
       * ```
       *
       * This is done by an additional scale by 1/pi, so is a fairly trivial operation but important conceptually.
       */
      convertIrradianceToLambertianRadiance() {
        this.scaleInPlace(1 / Math.PI);
      }
      /**
       * Integrates the reconstruction coefficients directly in to the SH preventing further
       * required operations at run time.
       *
       * This is simply done by scaling back the SH with Ylm constants parameter.
       * The trigonometric part being applied by the shader at run time.
       */
      preScaleForRendering() {
        this.preScaled = true;
        this.l00.scaleInPlace(SH3ylmBasisConstants[0]);
        this.l1_1.scaleInPlace(SH3ylmBasisConstants[1]);
        this.l10.scaleInPlace(SH3ylmBasisConstants[2]);
        this.l11.scaleInPlace(SH3ylmBasisConstants[3]);
        this.l2_2.scaleInPlace(SH3ylmBasisConstants[4]);
        this.l2_1.scaleInPlace(SH3ylmBasisConstants[5]);
        this.l20.scaleInPlace(SH3ylmBasisConstants[6]);
        this.l21.scaleInPlace(SH3ylmBasisConstants[7]);
        this.l22.scaleInPlace(SH3ylmBasisConstants[8]);
      }
      /**
       * update the spherical harmonics coefficients from the given array
       * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
       * @returns the spherical harmonics (this)
       */
      updateFromArray(data) {
        Vector3.FromArrayToRef(data[0], 0, this.l00);
        Vector3.FromArrayToRef(data[1], 0, this.l1_1);
        Vector3.FromArrayToRef(data[2], 0, this.l10);
        Vector3.FromArrayToRef(data[3], 0, this.l11);
        Vector3.FromArrayToRef(data[4], 0, this.l2_2);
        Vector3.FromArrayToRef(data[5], 0, this.l2_1);
        Vector3.FromArrayToRef(data[6], 0, this.l20);
        Vector3.FromArrayToRef(data[7], 0, this.l21);
        Vector3.FromArrayToRef(data[8], 0, this.l22);
        return this;
      }
      /**
       * update the spherical harmonics coefficients from the given floats array
       * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
       * @returns the spherical harmonics (this)
       */
      updateFromFloatsArray(data) {
        Vector3.FromFloatsToRef(data[0], data[1], data[2], this.l00);
        Vector3.FromFloatsToRef(data[3], data[4], data[5], this.l1_1);
        Vector3.FromFloatsToRef(data[6], data[7], data[8], this.l10);
        Vector3.FromFloatsToRef(data[9], data[10], data[11], this.l11);
        Vector3.FromFloatsToRef(data[12], data[13], data[14], this.l2_2);
        Vector3.FromFloatsToRef(data[15], data[16], data[17], this.l2_1);
        Vector3.FromFloatsToRef(data[18], data[19], data[20], this.l20);
        Vector3.FromFloatsToRef(data[21], data[22], data[23], this.l21);
        Vector3.FromFloatsToRef(data[24], data[25], data[26], this.l22);
        return this;
      }
      /**
       * Constructs a spherical harmonics from an array.
       * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
       * @returns the spherical harmonics
       */
      static FromArray(data) {
        const sh = new _SphericalHarmonics();
        return sh.updateFromArray(data);
      }
      // Keep for references.
      /**
       * Gets the spherical harmonics from polynomial
       * @param polynomial the spherical polynomial
       * @returns the spherical harmonics
       */
      static FromPolynomial(polynomial) {
        const result = new _SphericalHarmonics();
        result.l00 = polynomial.xx.scale(0.376127).add(polynomial.yy.scale(0.376127)).add(polynomial.zz.scale(0.376126));
        result.l1_1 = polynomial.y.scale(0.977204);
        result.l10 = polynomial.z.scale(0.977204);
        result.l11 = polynomial.x.scale(0.977204);
        result.l2_2 = polynomial.xy.scale(1.16538);
        result.l2_1 = polynomial.yz.scale(1.16538);
        result.l20 = polynomial.zz.scale(1.34567).subtract(polynomial.xx.scale(0.672834)).subtract(polynomial.yy.scale(0.672834));
        result.l21 = polynomial.zx.scale(1.16538);
        result.l22 = polynomial.xx.scale(1.16538).subtract(polynomial.yy.scale(1.16538));
        result.l1_1.scaleInPlace(-1);
        result.l11.scaleInPlace(-1);
        result.l2_1.scaleInPlace(-1);
        result.l21.scaleInPlace(-1);
        result.scaleInPlace(Math.PI);
        return result;
      }
    };
    SphericalPolynomial = class _SphericalPolynomial {
      constructor() {
        this.x = Vector3.Zero();
        this.y = Vector3.Zero();
        this.z = Vector3.Zero();
        this.xx = Vector3.Zero();
        this.yy = Vector3.Zero();
        this.zz = Vector3.Zero();
        this.xy = Vector3.Zero();
        this.yz = Vector3.Zero();
        this.zx = Vector3.Zero();
      }
      /**
       * The spherical harmonics used to create the polynomials.
       */
      get preScaledHarmonics() {
        if (!this._harmonics) {
          this._harmonics = SphericalHarmonics.FromPolynomial(this);
        }
        if (!this._harmonics.preScaled) {
          this._harmonics.preScaleForRendering();
        }
        return this._harmonics;
      }
      /**
       * Adds an ambient color to the spherical polynomial
       * @param color the color to add
       */
      addAmbient(color) {
        TmpVectors.Vector3[0].copyFromFloats(color.r, color.g, color.b);
        const colorVector = TmpVectors.Vector3[0];
        this.xx.addInPlace(colorVector);
        this.yy.addInPlace(colorVector);
        this.zz.addInPlace(colorVector);
      }
      /**
       * Scales the spherical polynomial by the given amount
       * @param scale the amount to scale
       */
      scaleInPlace(scale) {
        this.x.scaleInPlace(scale);
        this.y.scaleInPlace(scale);
        this.z.scaleInPlace(scale);
        this.xx.scaleInPlace(scale);
        this.yy.scaleInPlace(scale);
        this.zz.scaleInPlace(scale);
        this.yz.scaleInPlace(scale);
        this.zx.scaleInPlace(scale);
        this.xy.scaleInPlace(scale);
      }
      /**
       * Updates the spherical polynomial from harmonics
       * @param harmonics the spherical harmonics
       * @returns the spherical polynomial
       */
      updateFromHarmonics(harmonics) {
        this._harmonics = harmonics;
        this.x.copyFrom(harmonics.l11);
        this.x.scaleInPlace(1.02333).scaleInPlace(-1);
        this.y.copyFrom(harmonics.l1_1);
        this.y.scaleInPlace(1.02333).scaleInPlace(-1);
        this.z.copyFrom(harmonics.l10);
        this.z.scaleInPlace(1.02333);
        this.xx.copyFrom(harmonics.l00);
        TmpVectors.Vector3[0].copyFrom(harmonics.l20).scaleInPlace(0.247708);
        TmpVectors.Vector3[1].copyFrom(harmonics.l22).scaleInPlace(0.429043);
        this.xx.scaleInPlace(0.886277).subtractInPlace(TmpVectors.Vector3[0]).addInPlace(TmpVectors.Vector3[1]);
        this.yy.copyFrom(harmonics.l00);
        this.yy.scaleInPlace(0.886277).subtractInPlace(TmpVectors.Vector3[0]).subtractInPlace(TmpVectors.Vector3[1]);
        this.zz.copyFrom(harmonics.l00);
        TmpVectors.Vector3[0].copyFrom(harmonics.l20).scaleInPlace(0.495417);
        this.zz.scaleInPlace(0.886277).addInPlace(TmpVectors.Vector3[0]);
        this.yz.copyFrom(harmonics.l2_1);
        this.yz.scaleInPlace(0.858086).scaleInPlace(-1);
        this.zx.copyFrom(harmonics.l21);
        this.zx.scaleInPlace(0.858086).scaleInPlace(-1);
        this.xy.copyFrom(harmonics.l2_2);
        this.xy.scaleInPlace(0.858086);
        this.scaleInPlace(1 / Math.PI);
        return this;
      }
      /**
       * Gets the spherical polynomial from harmonics
       * @param harmonics the spherical harmonics
       * @returns the spherical polynomial
       */
      static FromHarmonics(harmonics) {
        const result = new _SphericalPolynomial();
        return result.updateFromHarmonics(harmonics);
      }
      /**
       * Constructs a spherical polynomial from an array.
       * @param data defines the 9x3 coefficients (x, y, z, xx, yy, zz, yz, zx, xy)
       * @returns the spherical polynomial
       */
      static FromArray(data) {
        const sp = new _SphericalPolynomial();
        Vector3.FromArrayToRef(data[0], 0, sp.x);
        Vector3.FromArrayToRef(data[1], 0, sp.y);
        Vector3.FromArrayToRef(data[2], 0, sp.z);
        Vector3.FromArrayToRef(data[3], 0, sp.xx);
        Vector3.FromArrayToRef(data[4], 0, sp.yy);
        Vector3.FromArrayToRef(data[5], 0, sp.zz);
        Vector3.FromArrayToRef(data[6], 0, sp.yz);
        Vector3.FromArrayToRef(data[7], 0, sp.zx);
        Vector3.FromArrayToRef(data[8], 0, sp.xy);
        return sp;
      }
    };
  }
});

// node_modules/@babylonjs/core/Misc/HighDynamicRange/cubemapToSphericalPolynomial.js
var FileFaceOrientation, CubeMapToSphericalPolynomialTools;
var init_cubemapToSphericalPolynomial = __esm({
  "node_modules/@babylonjs/core/Misc/HighDynamicRange/cubemapToSphericalPolynomial.js"() {
    "use strict";
    init_math_vector();
    init_math_scalar_functions();
    init_sphericalPolynomial();
    init_math_constants();
    init_math_color();
    FileFaceOrientation = class {
      constructor(name3, worldAxisForNormal, worldAxisForFileX, worldAxisForFileY) {
        this.name = name3;
        this.worldAxisForNormal = worldAxisForNormal;
        this.worldAxisForFileX = worldAxisForFileX;
        this.worldAxisForFileY = worldAxisForFileY;
      }
    };
    CubeMapToSphericalPolynomialTools = class {
      /**
       * Converts a texture to the according Spherical Polynomial data.
       * This extracts the first 3 orders only as they are the only one used in the lighting.
       *
       * @param texture The texture to extract the information from.
       * @returns The Spherical Polynomial data.
       */
      static ConvertCubeMapTextureToSphericalPolynomial(texture) {
        var _a;
        if (!texture.isCube) {
          return null;
        }
        (_a = texture.getScene()) == null ? void 0 : _a.getEngine().flushFramebuffer();
        const size = texture.getSize().width;
        const rightPromise = texture.readPixels(0, void 0, void 0, false);
        const leftPromise = texture.readPixels(1, void 0, void 0, false);
        let upPromise;
        let downPromise;
        if (texture.isRenderTarget) {
          upPromise = texture.readPixels(3, void 0, void 0, false);
          downPromise = texture.readPixels(2, void 0, void 0, false);
        } else {
          upPromise = texture.readPixels(2, void 0, void 0, false);
          downPromise = texture.readPixels(3, void 0, void 0, false);
        }
        const frontPromise = texture.readPixels(4, void 0, void 0, false);
        const backPromise = texture.readPixels(5, void 0, void 0, false);
        const gammaSpace = texture.gammaSpace;
        const format = 5;
        let type = 0;
        if (texture.textureType == 1 || texture.textureType == 2) {
          type = 1;
        }
        return new Promise((resolve) => {
          Promise.all([leftPromise, rightPromise, upPromise, downPromise, frontPromise, backPromise]).then(([left, right, up, down, front, back]) => {
            const cubeInfo = {
              size,
              right,
              left,
              up,
              down,
              front,
              back,
              format,
              type,
              gammaSpace
            };
            resolve(this.ConvertCubeMapToSphericalPolynomial(cubeInfo));
          });
        });
      }
      /**
       * Compute the area on the unit sphere of the rectangle defined by (x,y) and the origin
       * See https://www.rorydriscoll.com/2012/01/15/cubemap-texel-solid-angle/
       * @param x
       * @param y
       * @returns the area
       */
      static _AreaElement(x, y) {
        return Math.atan2(x * y, Math.sqrt(x * x + y * y + 1));
      }
      /**
       * Converts a cubemap to the according Spherical Polynomial data.
       * This extracts the first 3 orders only as they are the only one used in the lighting.
       *
       * @param cubeInfo The Cube map to extract the information from.
       * @returns The Spherical Polynomial data.
       */
      static ConvertCubeMapToSphericalPolynomial(cubeInfo) {
        const sphericalHarmonics = new SphericalHarmonics();
        let totalSolidAngle = 0;
        const du = 2 / cubeInfo.size;
        const dv = du;
        const halfTexel = 0.5 * du;
        const minUV = halfTexel - 1;
        for (let faceIndex = 0; faceIndex < 6; faceIndex++) {
          const fileFace = this._FileFaces[faceIndex];
          const dataArray = cubeInfo[fileFace.name];
          let v = minUV;
          const stride = cubeInfo.format === 5 ? 4 : 3;
          for (let y = 0; y < cubeInfo.size; y++) {
            let u = minUV;
            for (let x = 0; x < cubeInfo.size; x++) {
              const worldDirection = fileFace.worldAxisForFileX.scale(u).add(fileFace.worldAxisForFileY.scale(v)).add(fileFace.worldAxisForNormal);
              worldDirection.normalize();
              const deltaSolidAngle = this._AreaElement(u - halfTexel, v - halfTexel) - this._AreaElement(u - halfTexel, v + halfTexel) - this._AreaElement(u + halfTexel, v - halfTexel) + this._AreaElement(u + halfTexel, v + halfTexel);
              let r = dataArray[y * cubeInfo.size * stride + x * stride + 0];
              let g = dataArray[y * cubeInfo.size * stride + x * stride + 1];
              let b = dataArray[y * cubeInfo.size * stride + x * stride + 2];
              if (isNaN(r)) {
                r = 0;
              }
              if (isNaN(g)) {
                g = 0;
              }
              if (isNaN(b)) {
                b = 0;
              }
              if (cubeInfo.type === 0) {
                r /= 255;
                g /= 255;
                b /= 255;
              }
              if (cubeInfo.gammaSpace) {
                r = Math.pow(Clamp(r), ToLinearSpace);
                g = Math.pow(Clamp(g), ToLinearSpace);
                b = Math.pow(Clamp(b), ToLinearSpace);
              }
              const max = this.MAX_HDRI_VALUE;
              if (this.PRESERVE_CLAMPED_COLORS) {
                const currentMax = Math.max(r, g, b);
                if (currentMax > max) {
                  const factor = max / currentMax;
                  r *= factor;
                  g *= factor;
                  b *= factor;
                }
              } else {
                r = Clamp(r, 0, max);
                g = Clamp(g, 0, max);
                b = Clamp(b, 0, max);
              }
              const color = new Color3(r, g, b);
              sphericalHarmonics.addLight(worldDirection, color, deltaSolidAngle);
              totalSolidAngle += deltaSolidAngle;
              u += du;
            }
            v += dv;
          }
        }
        const sphereSolidAngle = 4 * Math.PI;
        const facesProcessed = 6;
        const expectedSolidAngle = sphereSolidAngle * facesProcessed / 6;
        const correctionFactor = expectedSolidAngle / totalSolidAngle;
        sphericalHarmonics.scaleInPlace(correctionFactor);
        sphericalHarmonics.convertIncidentRadianceToIrradiance();
        sphericalHarmonics.convertIrradianceToLambertianRadiance();
        return SphericalPolynomial.FromHarmonics(sphericalHarmonics);
      }
    };
    CubeMapToSphericalPolynomialTools._FileFaces = [
      new FileFaceOrientation("right", new Vector3(1, 0, 0), new Vector3(0, 0, -1), new Vector3(0, -1, 0)),
      new FileFaceOrientation("left", new Vector3(-1, 0, 0), new Vector3(0, 0, 1), new Vector3(0, -1, 0)),
      new FileFaceOrientation("up", new Vector3(0, 1, 0), new Vector3(1, 0, 0), new Vector3(0, 0, 1)),
      new FileFaceOrientation("down", new Vector3(0, -1, 0), new Vector3(1, 0, 0), new Vector3(0, 0, -1)),
      new FileFaceOrientation("front", new Vector3(0, 0, 1), new Vector3(1, 0, 0), new Vector3(0, -1, 0)),
      new FileFaceOrientation("back", new Vector3(0, 0, -1), new Vector3(-1, 0, 0), new Vector3(0, -1, 0))
      // -Z bottom
    ];
    CubeMapToSphericalPolynomialTools.MAX_HDRI_VALUE = 4096;
    CubeMapToSphericalPolynomialTools.PRESERVE_CLAMPED_COLORS = false;
  }
});

// node_modules/@babylonjs/core/PostProcesses/passPostProcess.js
var PassPostProcess, PassCubePostProcess;
var init_passPostProcess = __esm({
  "node_modules/@babylonjs/core/PostProcesses/passPostProcess.js"() {
    "use strict";
    init_postProcess();
    init_abstractEngine();
    init_typeStore();
    init_decorators_serialization();
    PassPostProcess = class _PassPostProcess extends PostProcess {
      /**
       * Gets a string identifying the name of the class
       * @returns "PassPostProcess" string
       */
      getClassName() {
        return "PassPostProcess";
      }
      /**
       * Creates the PassPostProcess
       * @param name The name of the effect.
       * @param options The required width/height ratio to downsize to before computing the render pass.
       * @param camera The camera to apply the render pass to.
       * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
       * @param engine The engine which the post process will be applied. (default: current engine)
       * @param reusable If the post process can be reused on the same frame. (default: false)
       * @param textureType The type of texture to be used when performing the post processing.
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       */
      constructor(name3, options, camera = null, samplingMode, engine, reusable, textureType = 0, blockCompilation = false) {
        super(name3, "pass", null, null, options, camera, samplingMode, engine, reusable, void 0, textureType, void 0, null, blockCompilation);
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(Promise.all([import("./pass.fragment-TENMQRVZ.mjs")]));
        } else {
          list.push(Promise.all([import("./pass.fragment-KVDRKMBF.mjs")]));
        }
        super._gatherImports(useWebGPU, list);
      }
      /**
       * @internal
       */
      static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return SerializationHelper.Parse(() => {
          return new _PassPostProcess(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, parsedPostProcess._engine, parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
      }
    };
    RegisterClass("BABYLON.PassPostProcess", PassPostProcess);
    PassCubePostProcess = class _PassCubePostProcess extends PostProcess {
      /**
       * Gets or sets the cube face to display.
       *  * 0 is +X
       *  * 1 is -X
       *  * 2 is +Y
       *  * 3 is -Y
       *  * 4 is +Z
       *  * 5 is -Z
       */
      get face() {
        return this._face;
      }
      set face(value) {
        if (value < 0 || value > 5) {
          return;
        }
        this._face = value;
        switch (this._face) {
          case 0:
            this.updateEffect("#define POSITIVEX");
            break;
          case 1:
            this.updateEffect("#define NEGATIVEX");
            break;
          case 2:
            this.updateEffect("#define POSITIVEY");
            break;
          case 3:
            this.updateEffect("#define NEGATIVEY");
            break;
          case 4:
            this.updateEffect("#define POSITIVEZ");
            break;
          case 5:
            this.updateEffect("#define NEGATIVEZ");
            break;
        }
      }
      /**
       * Gets a string identifying the name of the class
       * @returns "PassCubePostProcess" string
       */
      getClassName() {
        return "PassCubePostProcess";
      }
      /**
       * Creates the PassCubePostProcess
       * @param name The name of the effect.
       * @param options The required width/height ratio to downsize to before computing the render pass.
       * @param camera The camera to apply the render pass to.
       * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
       * @param engine The engine which the post process will be applied. (default: current engine)
       * @param reusable If the post process can be reused on the same frame. (default: false)
       * @param textureType The type of texture to be used when performing the post processing.
       * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
       */
      constructor(name3, options, camera = null, samplingMode, engine, reusable, textureType = 0, blockCompilation = false) {
        super(name3, "passCube", null, null, options, camera, samplingMode, engine, reusable, "#define POSITIVEX", textureType, void 0, null, blockCompilation);
        this._face = 0;
      }
      _gatherImports(useWebGPU, list) {
        if (useWebGPU) {
          this._webGPUReady = true;
          list.push(Promise.all([import("./passCube.fragment-EYCNYH3X.mjs")]));
        } else {
          list.push(Promise.all([import("./passCube.fragment-4VJWQJL3.mjs")]));
        }
        super._gatherImports(useWebGPU, list);
      }
      /**
       * @internal
       */
      static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return SerializationHelper.Parse(() => {
          return new _PassCubePostProcess(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, parsedPostProcess._engine, parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
      }
    };
    AbstractEngine._RescalePostProcessFactory = (engine) => {
      return new PassPostProcess("rescale", 1, null, 2, engine, false, 0);
    };
  }
});

// node_modules/@babylonjs/core/Shaders/lod.fragment.js
var name, shader;
var init_lod_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/lod.fragment.js"() {
    "use strict";
    init_shaderStore();
    name = "lodPixelShader";
    shader = `#extension GL_EXT_shader_texture_lod : enable
precision highp float;const float GammaEncodePowerApprox=1.0/2.2;varying vec2 vUV;uniform sampler2D textureSampler;uniform float lod;uniform vec2 texSize;uniform bool gamma;void main(void)
{gl_FragColor=textureLod(textureSampler,vUV,lod);if (!gamma) {gl_FragColor.rgb=pow(gl_FragColor.rgb,vec3(GammaEncodePowerApprox));}}
`;
    ShaderStore.ShadersStore[name] = shader;
  }
});

// node_modules/@babylonjs/core/Shaders/lodCube.fragment.js
var name2, shader2;
var init_lodCube_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/lodCube.fragment.js"() {
    "use strict";
    init_shaderStore();
    name2 = "lodCubePixelShader";
    shader2 = `precision highp float;const float GammaEncodePowerApprox=1.0/2.2;varying vec2 vUV;uniform samplerCube textureSampler;uniform float lod;uniform bool gamma;void main(void)
{vec2 uv=vUV*2.0-1.0;
#ifdef POSITIVEX
gl_FragColor=textureCube(textureSampler,vec3(1.001,uv.y,uv.x),lod);
#endif
#ifdef NEGATIVEX
gl_FragColor=textureCube(textureSampler,vec3(-1.001,uv.y,uv.x),lod);
#endif
#ifdef POSITIVEY
gl_FragColor=textureCube(textureSampler,vec3(uv.y,1.001,uv.x),lod);
#endif
#ifdef NEGATIVEY
gl_FragColor=textureCube(textureSampler,vec3(uv.y,-1.001,uv.x),lod);
#endif
#ifdef POSITIVEZ
gl_FragColor=textureCube(textureSampler,vec3(uv,1.001),lod);
#endif
#ifdef NEGATIVEZ
gl_FragColor=textureCube(textureSampler,vec3(uv,-1.001),lod);
#endif
if (!gamma) {gl_FragColor.rgb=pow(gl_FragColor.rgb,vec3(GammaEncodePowerApprox));}}
`;
    ShaderStore.ShadersStore[name2] = shader2;
  }
});

// node_modules/@babylonjs/core/Misc/textureTools.js
function CreateResizedCopy(texture, width, height, useBilinearMode = true) {
  const scene = texture.getScene();
  const engine = scene.getEngine();
  const rtt = new RenderTargetTexture("resized" + texture.name, { width, height }, scene, !texture.noMipmap, true, texture._texture.type, false, texture.samplingMode, false);
  rtt.wrapU = texture.wrapU;
  rtt.wrapV = texture.wrapV;
  rtt.uOffset = texture.uOffset;
  rtt.vOffset = texture.vOffset;
  rtt.uScale = texture.uScale;
  rtt.vScale = texture.vScale;
  rtt.uAng = texture.uAng;
  rtt.vAng = texture.vAng;
  rtt.wAng = texture.wAng;
  rtt.coordinatesIndex = texture.coordinatesIndex;
  rtt.level = texture.level;
  rtt.anisotropicFilteringLevel = texture.anisotropicFilteringLevel;
  rtt._texture.isReady = false;
  texture.wrapU = Texture.CLAMP_ADDRESSMODE;
  texture.wrapV = Texture.CLAMP_ADDRESSMODE;
  const passPostProcess = new PassPostProcess("pass", 1, null, useBilinearMode ? Texture.BILINEAR_SAMPLINGMODE : Texture.NEAREST_SAMPLINGMODE, engine, false, 0);
  passPostProcess.externalTextureSamplerBinding = true;
  passPostProcess.onEffectCreatedObservable.addOnce((e) => {
    e.executeWhenCompiled(() => {
      passPostProcess.onApply = function(effect) {
        effect.setTexture("textureSampler", texture);
      };
      const internalTexture = rtt.renderTarget;
      if (internalTexture) {
        scene.postProcessManager.directRender([passPostProcess], internalTexture);
        engine.unBindFramebuffer(internalTexture);
        rtt.disposeFramebufferObjects();
        passPostProcess.dispose();
        rtt.getInternalTexture().isReady = true;
      }
    });
  });
  return rtt;
}
function ApplyPostProcess(postProcessName, internalTexture, scene, type, samplingMode, format, width, height) {
  const engine = internalTexture.getEngine();
  internalTexture.isReady = false;
  samplingMode = samplingMode != null ? samplingMode : internalTexture.samplingMode;
  type = type != null ? type : internalTexture.type;
  format = format != null ? format : internalTexture.format;
  width = width != null ? width : internalTexture.width;
  height = height != null ? height : internalTexture.height;
  if (type === -1) {
    type = 0;
  }
  return new Promise((resolve) => {
    const postProcess = new PostProcess("postprocess", postProcessName, null, null, 1, null, samplingMode, engine, false, void 0, type, void 0, null, false, format);
    postProcess.externalTextureSamplerBinding = true;
    const encodedTexture = engine.createRenderTargetTexture({ width, height }, {
      generateDepthBuffer: false,
      generateMipMaps: false,
      generateStencilBuffer: false,
      samplingMode,
      type,
      format
    });
    postProcess.onEffectCreatedObservable.addOnce((e) => {
      e.executeWhenCompiled(() => {
        postProcess.onApply = (effect) => {
          effect._bindTexture("textureSampler", internalTexture);
          effect.setFloat2("scale", 1, 1);
        };
        scene.postProcessManager.directRender([postProcess], encodedTexture, true);
        engine.restoreDefaultFramebuffer();
        engine._releaseTexture(internalTexture);
        if (postProcess) {
          postProcess.dispose();
        }
        encodedTexture._swapAndDie(internalTexture);
        internalTexture.type = type;
        internalTexture.format = 5;
        internalTexture.isReady = true;
        resolve(internalTexture);
      });
    });
  });
}
function ToHalfFloat(value) {
  if (!floatView) {
    floatView = new Float32Array(1);
    int32View = new Int32Array(floatView.buffer);
  }
  floatView[0] = value;
  const x = int32View[0];
  let bits = x >> 16 & 32768;
  let m = x >> 12 & 2047;
  const e = x >> 23 & 255;
  if (e < 103) {
    return bits;
  }
  if (e > 142) {
    bits |= 31744;
    bits |= (e == 255 ? 0 : 1) && x & 8388607;
    return bits;
  }
  if (e < 113) {
    m |= 2048;
    bits |= (m >> 114 - e) + (m >> 113 - e & 1);
    return bits;
  }
  bits |= e - 112 << 10 | m >> 1;
  bits += m & 1;
  return bits;
}
function FromHalfFloat(value) {
  const s = (value & 32768) >> 15;
  const e = (value & 31744) >> 10;
  const f = value & 1023;
  if (e === 0) {
    return (s ? -1 : 1) * Math.pow(2, -14) * (f / Math.pow(2, 10));
  } else if (e == 31) {
    return f ? NaN : (s ? -1 : 1) * Infinity;
  }
  return (s ? -1 : 1) * Math.pow(2, e - 15) * (1 + f / Math.pow(2, 10));
}
function GetTextureDataAsync(texture, width, height, face = 0, lod = 0) {
  return __async(this, null, function* () {
    if (!texture.isReady() && texture._texture) {
      yield new Promise((resolve, reject) => {
        if (texture._texture === null) {
          reject(0);
          return;
        }
        texture._texture.onLoadedObservable.addOnce(() => {
          resolve(0);
        });
      });
    }
    return yield ProcessAsync(texture, width, height, face, lod);
  });
}
var floatView, int32View, ProcessAsync, TextureTools;
var init_textureTools = __esm({
  "node_modules/@babylonjs/core/Misc/textureTools.js"() {
    "use strict";
    init_texture();
    init_renderTargetTexture();
    init_passPostProcess();
    init_postProcess();
    init_lod_fragment();
    init_lodCube_fragment();
    ProcessAsync = (texture, width, height, face, lod) => __async(void 0, null, function* () {
      const scene = texture.getScene();
      const engine = scene.getEngine();
      let lodPostProcess;
      if (!texture.isCube) {
        lodPostProcess = new PostProcess("lod", "lod", ["lod", "gamma"], null, 1, null, Texture.NEAREST_NEAREST_MIPNEAREST, engine);
      } else {
        const faceDefines = ["#define POSITIVEX", "#define NEGATIVEX", "#define POSITIVEY", "#define NEGATIVEY", "#define POSITIVEZ", "#define NEGATIVEZ"];
        lodPostProcess = new PostProcess("lodCube", "lodCube", ["lod", "gamma"], null, 1, null, Texture.NEAREST_NEAREST_MIPNEAREST, engine, false, faceDefines[face]);
      }
      yield new Promise((resolve) => {
        lodPostProcess.onEffectCreatedObservable.addOnce((e) => {
          e.executeWhenCompiled(() => {
            resolve(0);
          });
        });
      });
      const rtt = new RenderTargetTexture("temp", { width, height }, scene, false);
      lodPostProcess.onApply = function(effect) {
        effect.setTexture("textureSampler", texture);
        effect.setFloat("lod", lod);
        effect.setBool("gamma", texture.gammaSpace);
      };
      const internalTexture = texture.getInternalTexture();
      try {
        if (rtt.renderTarget && internalTexture) {
          const samplingMode = internalTexture.samplingMode;
          if (lod !== 0) {
            texture.updateSamplingMode(Texture.NEAREST_NEAREST_MIPNEAREST);
          } else {
            texture.updateSamplingMode(Texture.NEAREST_NEAREST);
          }
          scene.postProcessManager.directRender([lodPostProcess], rtt.renderTarget, true);
          texture.updateSamplingMode(samplingMode);
          const bufferView = yield engine.readPixels(0, 0, width, height);
          const data = new Uint8Array(bufferView.buffer, 0, bufferView.byteLength);
          engine.unBindFramebuffer(rtt.renderTarget);
          return data;
        } else {
          throw Error("Render to texture failed.");
        }
      } finally {
        rtt.dispose();
        lodPostProcess.dispose();
      }
    });
    TextureTools = {
      /**
       * Uses the GPU to create a copy texture rescaled at a given size
       * @param texture Texture to copy from
       * @param width defines the desired width
       * @param height defines the desired height
       * @param useBilinearMode defines if bilinear mode has to be used
       * @returns the generated texture
       */
      CreateResizedCopy,
      /**
       * Apply a post process to a texture
       * @param postProcessName name of the fragment post process
       * @param internalTexture the texture to encode
       * @param scene the scene hosting the texture
       * @param type type of the output texture. If not provided, use the one from internalTexture
       * @param samplingMode sampling mode to use to sample the source texture. If not provided, use the one from internalTexture
       * @param format format of the output texture. If not provided, use the one from internalTexture
       * @returns a promise with the internalTexture having its texture replaced by the result of the processing
       */
      ApplyPostProcess,
      /**
       * Converts a number to half float
       * @param value number to convert
       * @returns converted number
       */
      ToHalfFloat,
      /**
       * Converts a half float to a number
       * @param value half float to convert
       * @returns converted half float
       */
      FromHalfFloat,
      /**
       * Gets the data of the specified texture by rendering it to an intermediate RGBA texture and retrieving the bytes from it.
       * This is convienent to get 8-bit RGBA values for a texture in a GPU compressed format.
       * @param texture the source texture
       * @param width the width of the result, which does not have to match the source texture width
       * @param height the height of the result, which does not have to match the source texture height
       * @param face if the texture has multiple faces, the face index to use for the source
       * @param channels a filter for which of the RGBA channels to return in the result
       * @param lod if the texture has multiple LODs, the lod index to use for the source
       * @returns the 8-bit texture data
       */
      GetTextureDataAsync
    };
  }
});

export {
  Space,
  Axis,
  Coordinate,
  init_math_axis,
  PositionNormalVertex,
  PositionNormalTextureVertex,
  init_math,
  SphericalHarmonics,
  SphericalPolynomial,
  init_sphericalPolynomial,
  CubeMapToSphericalPolynomialTools,
  init_cubemapToSphericalPolynomial,
  PassPostProcess,
  PassCubePostProcess,
  init_passPostProcess,
  CreateResizedCopy,
  ApplyPostProcess,
  ToHalfFloat,
  FromHalfFloat,
  GetTextureDataAsync,
  TextureTools,
  init_textureTools
};
